/* eslint-disable */
let envConfig = require('./env_cfg/envCfg')
export default {
    baseURL: '',
    imageDomain: envConfig.imageDomain,
    gateway: {
        "x-app-id": 'com.huawei.it.mbs.eventsgo',
        // 子业务配置信息
        "x-sub-app-id": 'eventsgocommon',
        "context": '/common',

        // 多租户配置信息
        "x-multi-consumer-appid": 'com.huawei.it.mbs.eventsgo',
        "x-multi-consumer-sub-appid": 'eventsgocommon',
        "x-multi-consumer-context": '/common',

        // 网关地址
        MsaGatewayAddress: envConfig.MsaGatewayAddress,
        services: {
            "eventsgo/common": {
                "x-app-id": 'com.huawei.it.mbs.eventsgo',
                // 子业务配置信息
                "x-sub-app-id": 'eventsgocommon',
                "context": ''
            },
            "eventsgo/hotel": {
                "x-app-id": 'com.huawei.mbs.cims.eventsgohotel',
                "x-sub-app-id": 'eventsgohotel',
                "context": ''
            },
            "eventsgo/public": {
                "x-app-id": 'com.huawei.mbs.cims.eventsgopublic',
                "x-sub-app-id": 'eventsgopublic',
                "context": ''
            },
            "eventsgo/attachment": {
                "x-app-id": 'com.huawei.it.mbs.eventsgo',
                "x-sub-app-id": 'eventsgoattachment',
                "context": ''
            },
            "eventsgo/vehicle": {
                "x-app-id": 'com.huawei.mbs.cims.eventsgovehicle',
                "x-sub-app-id": 'eventsgovehicle',
                "context": ''
            },
            "eventsgo/finance": { // 财务管理相关上下文
                "x-app-id": 'com.huawei.mbs.cims.eventsgofinance',
                "x-sub-app-id": 'eventsgofinance',
                "context": ''
            },
            "eventsgo/media": { // 媒体相关上下文
                "x-app-id": 'com.huawei.it.mbs.eventsgo',
                "x-sub-app-id": 'eventsgomedia',
                "context": ''
            },
            "eventsgo/personcenter": {
                "x-app-id": 'com.huawei.mbs.cims.eventsgoperson',
                "x-sub-app-id": 'eventsgopersoncenter',
                "context": ''
            }
        }
    }
}
